import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { Box } from "../../../Box/index.js";
import { ColoredChip } from "../../../ColoredChip/index.js";
import { Tooltip } from "../../../Tooltip/index.js";
import { useIsDesktop } from "../../../hooks/index.js";
const Badge = (t0)=>{
    const $ = c(9);
    const { title: t1, description: t2, color, size: t3, width } = t0;
    const title = void 0 === t1 ? "" : t1;
    const description = void 0 === t2 ? "" : t2;
    const size = void 0 === t3 ? "small" : t3;
    const isDesktop = useIsDesktop();
    const t4 = !isDesktop;
    const t5 = "velvet" === color ? "purple" : color || "blue";
    let t6;
    if ($[0] !== size || $[1] !== t5 || $[2] !== title || $[3] !== width) {
        t6 = /*#__PURE__*/ jsx("span", {
            children: /*#__PURE__*/ jsx(ColoredChip, {
                width: width,
                fullWidth: true,
                size: size,
                color: t5,
                label: title
            })
        });
        $[0] = size;
        $[1] = t5;
        $[2] = title;
        $[3] = width;
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== description || $[6] !== t4 || $[7] !== t6) {
        t7 = /*#__PURE__*/ jsx(Box, {
            children: /*#__PURE__*/ jsx(Tooltip, {
                disabled: t4,
                title: description,
                placement: "left",
                children: t6
            })
        });
        $[5] = description;
        $[6] = t4;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
};
export { Badge };
